// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2RsUP","content":"styles_content__3AV4t","checkbox":"styles_checkbox__3o9Y4","checkboxLabel":"styles_checkboxLabel__DLDUT"};